// extracted by mini-css-extract-plugin
export default {"eventTypeTagBlue":"EventTypeTag_eventTypeTagBlue__Vnz8I","label":"EventTypeTag_label__+ESRs","eventTypeTagCardholderExclusive":"EventTypeTag_eventTypeTagCardholderExclusive__cZK+I"};